<template>
	<ErrorPage />
</template>

<script>
import adobeLaunchService from "../services/adobeLaunchService.js";
import ErrorPage from "@vg-faset/ui/src/components/error-page/ErrorPage.vue";

export default {
	name: "TaxCenterErrorPage",
	components: {
		ErrorPage
	},
	data() {
		return {
			is404: "Y"
		};
	},
	created() {
		setTimeout(() => {
			adobeLaunchService.trackPageLoad(this.is404);
		}, 0);
	}
};
</script>

<style lang="scss">
.error-page {
	padding: 80px 0;
}
</style>
